import type { EditorController } from "@/editor/create-editor";

/** Editor em foco no momento (o painel de IA lê a seleção; sugestões revelam linhas). */
export const activeEditor: { current: EditorController | null } = { current: null };
